import {
  Directive,
  HostBinding,
  Input,
  OnInit,
  OnDestroy,
  ElementRef,
  Renderer2,
  ChangeDetectorRef,
  HostListener,
} from '@angular/core';

import { Observable } from 'rxjs';

import { FormGroupService } from './form-group.service';
import { getStringWithSpecialSymbolsLength } from 'shared/validation/lengthSpec-validation';
import {fromEvent} from 'rxjs/internal/observable/fromEvent';
import {takeWhile} from 'rxjs/operators';


@Directive({
  selector: '[bsFormControl]',
  exportAs: 'bs-form-control'
})
export class FormControlDirective implements OnInit, OnDestroy {
  isActive: boolean = true;

  @HostBinding('class.form-control') formClass: boolean = true;

  @HostBinding('class.form-control-danger')
  @Input() hasError: boolean = false;

  @HostBinding('class.form-control-success')
  @Input() hasSuccess: boolean = false;

  @HostBinding('class.form-control-date')
  @Input() hasDate: boolean = false;

  @HostBinding('attr.placeholder')
  @Input() placeholder: string = '';

  @HostBinding('class.version-2')
  @Input() isVersion2: boolean = false;

  @HostBinding('class.no-border')
  noBorder: boolean = false;

  @Input() charCounter: boolean = false;

    // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('validateFormControl') validateFormControl: any;

  @Input() validateOnBlur: boolean = false;

  @Input() set border(border: boolean) {
    this.noBorder = !border;
  }

  @Input() set numerical(numerical: boolean) {
    this.renderer.setAttribute(
      this.elementRef.nativeElement,
      'type',
      numerical ? 'number' : 'text'
    );
  }

  private events: any = [
    {
      name: 'focus',
      func: 'onFocus'
    },
    {
      name: 'blur',
      func: 'onBlur'
    },
    {
      name: 'keyup',
      func: 'onChange'
    },
    {
      name: 'change',
      func: 'onChange'
    }
  ];

  @HostListener('blur', ['$event.target'])
  onElBlur(element: HTMLInputElement) {
    if (this.validateOnBlur && this.validateFormControl) {
      this.validateFormControl.markAsTouched();
    }
  }

  @HostListener('keyup', ['$event.target'])
  onElKeyup(element: HTMLInputElement) {
    if (this.validateOnBlur && this.validateFormControl) {
      this.validateFormControl.markAsUntouched();
    }
  }

  @HostListener('focus', ['$event.target'])
  onElFocus(element: HTMLInputElement) {
    if (this.validateOnBlur && this.validateFormControl) {
      this.validateFormControl.markAsUntouched();
    }
  }

  constructor(
    private formGroupService: FormGroupService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private ref: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    if (!this.charCounter) { return; }
    this._addCharCounterSubscribes();
  }

  ngOnDestroy() {
    this.isActive = false;
  }

  onFocus() {
    const length = getStringWithSpecialSymbolsLength(this.elementRef.nativeElement.value);
    this.formGroupService.focus(length);
    this.ref.markForCheck();
  }

  onBlur() {
    this.formGroupService.setFocused(false);
    this.ref.markForCheck();
  }

  onChange(event: any) {
    const length = getStringWithSpecialSymbolsLength(event.target.value);
    this.formGroupService.setCharLength(length);
    this.ref.markForCheck();
  }

  private _addCharCounterSubscribes() {
    const element = this.elementRef.nativeElement;
    this.events.forEach((item: any) => {
      fromEvent(element, item.name)
      .pipe(takeWhile(() => this.isActive))
      .subscribe((<any>this)[item.func].bind(this));
    });

  }

}
